export const CREDIT_NOTES = gql`
    query CreditNotes {
        creditNotes {
            id
            sageCreditNoteNumber
            partner {
                id
                name
                firstName
                lastName
                billingContactInformation
                primaryContactInformation
                business {
                    legalName
                }
            }
            merchant {
                id
                business {
                    legalName
                }
            }
            invoiceToType
            reason
            salesInvoice {
                id
                sageInvoiceNumber
                sageInvoiceId
            }
            totalCreditNetAmount
            totalCreditVatAmount
            totalCreditAmount
            createdAt
            updatedAt
        }
    }
`;

export const CREDIT_NOTES_PAGINATED = gql`
    query CreditNotesPaginated($filters: CreditNotesTableFiltersInput) {
        creditNotesPaginated(filters: $filters) {
            data {
                id
                sageCreditNoteNumber
                merchantName
                partnerName
                dateAdded
                invoiceNumber
                creditValue
            }
            total
            page
            pageSize
        }
    }
`;
